import React from "react";
import NurserySection from "./NurserySection";
import AboutUsSection from "./AboutUsSection";
import MainSection from "./MainSection";
import SubmitSection from "./SubmitSection";
import ProductSection from "./ProductSection";
import FeaturedSection from "./FeaturedSection";

const Landing = () => {
  return (
    <>
      <MainSection />
      <AboutUsSection />
      <ProductSection />
      <FeaturedSection />
      <NurserySection />
      <SubmitSection />
    </>
  );
};

export default Landing;
